import { authHeaders } from '@/lib/authHeaders';

/**
 * CREDENTIALS A GUIDE NEEDS — the client side of /api/guide-secrets (9 Oct 2026).
 *
 * The guides are a public JavaScript file: anything written in them can be
 * downloaded without signing in. So a guide names the value by id and the
 * server hands it over only to a signed-in person of the guide's country.
 * Nothing here is cached or stored: the value lives in the box's state while
 * it is shown, and is dropped on Hide.
 */
export interface GuideSecretField {
  key: string;
  /** The form's own field name (e.g. the Portal das Finanças label). */
  label: string;
  /** null = the server has no value yet (its environment variable is unset). */
  value: string | null;
  /** The credential itself, as opposed to the data that goes with it. */
  secret: boolean;
}

/** Why the server said no — the box words each case its own way. */
export class GuideSecretError extends Error {
  status: number;
  constructor(status: number, message: string) { super(message); this.status = status; }
}

export async function readGuideSecret(id: string, signal?: AbortSignal): Promise<GuideSecretField[]> {
  const r = await fetch(`/api/guide-secrets/${encodeURIComponent(id)}`, {
    headers: await authHeaders(),
    cache: 'no-store',
    signal,
  });
  if (!r.ok) {
    let detail = '';
    try { detail = (await r.json())?.error || ''; } catch { /* not JSON */ }
    throw new GuideSecretError(r.status, `${r.status} ${detail}`.trim());
  }
  const body = (await r.json()) as { fields?: GuideSecretField[] };
  return Array.isArray(body.fields) ? body.fields : [];
}
